// THIS FILE IS AUTO-GENERATED. PLEASE DO NOT MODIFY IT DIRECTLY.
// IF MODIFICATIONS ARE NEEDED, PLEASE EDIT THE error.csv FILE, AND THEN RUN "npm run errorgen".

// -1 - failed
// 0 - success
// 1000-1999 - user side error
// 2000-2999 - js bridge/webview error/user cancel action
// 3000-3999 - native side error

export enum ERROR_CODE {
  SUCCESS = 0, // everything is ok.
  FAILED = -1, // hybrid failed.
  REQUEST_PARAM_ERROR = 1001, // param missing or illegal
  CANCEL_SCREENSHOT = 1002, // user canceled screenshot
  ALREADY_IN_SCREENSHOT_PROGRESS = 1004, // screenshot is not allowed while a previous screenshot is still in progress.
  EXCEED_MAX_FILE_SIZE = 1005, // file size exceed max size
  FILE_READ_INVALID_RANGE = 1006, // The rangeStart or rangeEnd parameter is invalid
  FILE_READ_RANGE_TOO_LARGE = 1007, // The MAX_FILE_SIZE is 60 x 1024 x 1024
  WEBVIEW_MISSING_SYSTEM_PARAM = 2002, // can't found system param for api available checking
  CANCEL_SELECT_PATH = 2003, // user canceled file path selection
  FILE_FAILED_TO_GET_FILE_ABILITY = 2004, // failed to get file ability
  FILE_FAILED_TO_GET_FILE_INFO = 2005, // failed to get file info
  START_DOWNLOAD_FAILED_OR_SCREENSHOT_SIZE_EXCEED_LIMIT = 3001, // start download failed or screenshot data size exceed the size limitation
  PAUSE_DOWNLOAD_FAILED_OR_SCREENSHOT_DEVICE_OCCUPIED = 3002, // pause download failed or screenshot device was occupied
  RESUME_DOWNLOAD_FAILED_OR_SCREENSHOT_PERMISSION_DENIED = 3003, // resume download failed or screenshot permission was denied
  CANCEL_DOWNLOAD_FAILED = 3004, // cancel download failed
  GET_DOWNLOAD_INFO_FAILED = 3005, // get download info failed
  REQUEST_TIMEOUT = 3006, // request timeout
  FILE_SYSTEM_SAVE_FILE_FAILED = 3007, // file stream save as file failed
  HTTP_HOOK_FILE_TO_LARGE = 3008, // The HTTP body size exceeds the security limitation (20 MB).
  HTTP_HOOK_TO_MANY_REQUEST = 3009, // Too many concurrent HTTP body requests. The limitation is 20 requests at the same time.
  HTTP_HOOK_INVALID_BODY_FORMAT = 3010, // The body data format is invalid.
  CLIENT_SETTING_NOT_EXIST = 3011, // The client setting doesn't contain the user requested setting key.
  HTTP_REQUEST_INVALID_PROTOCOL = 3012, // The HTTP request URL must use HTTPS scheme
  HTTP_REQUEST_INVALID_PATH = 3013, // The HTTP request should not contain relative path
  HTTP_REQUEST_INVALID_DOMAIN = 3014, // The HTTP request URL must belong to a Zoom domain
  FILE_READ_OUT_OF_RANGE = 3015, // The rangeStart or rangeEnd parameter out of range.
  FILE_READ_FILE_NOT_FOUND = 3016, // The file corresponding to the pathId does not exist.
  FILE_READ_ERROR = 3017, // Error occurred while reading the file
  ERROR_NO_PERMISSION = 3018, // ERROR_NO_PERMISSION
  ERROR_PARAM_MISSING = 3019, // ERROR_PARAM_MISSING
  ERROR_PARAM_INVALID = 3020, // ERROR_PARAM_INVALID
  ERROR_USER_CANCEL = 3021, // ERROR_USER_CANCEL
  UNKNOWN_ERROR = 3022, // UNKNOWN_ERROR
  OPERATION_CANCELED = 3026, // OPERATION_CANCELED
  RESOURCE_UNAVAILABLE = 3027, // RESOURCE_UNAVAILABLE
  DATA_ERROR = 3028, // DATA_ERROR
  CALL_INTERVAL_TOO_SHORT = 3029, // openSysFileExplorer CALL_INTERVAL_TOO_SHORT
}
